import { useSyncExternalStore } from 'react';
import { subscribeAuthError, getAuthErrorSnapshot, resetReauthGuard } from '@lib/apiClient';

/**
 * Visible auth-error surface (Diamond Spec Rev4 D9). Renders only after the ONE
 * permitted interactive re-auth has been spent and a gated /api call 401s
 * again: the alternative is a silent dead page or a redirect storm, both worse.
 * Try again is the named explicit reset - it re-arms the single re-auth and
 * reloads so the page re-fetches with a fresh token attempt.
 */
export function AuthErrorBanner() {
  const hasError = useSyncExternalStore(subscribeAuthError, getAuthErrorSnapshot);
  if (!hasError) return null;
  return (
    <div
      role="alert"
      className="fixed inset-x-0 top-0 z-[1000] flex items-center justify-center gap-3 bg-cdx-danger px-4 py-2 text-sm font-semibold text-white shadow-md"
    >
      <span>
        Your session has expired or your sign-in could not be confirmed. Re-open
        your personalized access link from your email, or press Try again.
        Private / InPrivate windows can block the Microsoft sign-in, so please
        use a standard browser window.
      </span>
      <button
        type="button"
        className="rounded border border-white/60 px-2 py-0.5 text-xs font-bold uppercase tracking-wide hover:bg-white/10"
        onClick={() => { resetReauthGuard(); window.location.reload(); }}
      >
        Try again
      </button>
    </div>
  );
}
